import {createContext} from  "react";
export type AppContextType = {
    userData: any, setUserData: any, errorMessage: any, setErrorMessage: any, successMessage: any,
      setSuccessMessage: any, showLoader: any, setShowLoader: any, setDialogMessage: any
  };
export const AppContext = createContext<AppContextType>({} as AppContextType);